import { bbRequestError } from './http';
import { bbEnableAllBtns, bbSetBBPhase } from './utils'
import { bbSelectErrorValidation } from './validations';
import { afterInitialized } from './configuration';

function variables() {

    var bbConfig;
    var bbUrlBase = '';
    var bbToken = '';
    var bbCardFields;
    var bbCurrentPhase;
    var bbPhases = {
        BB_INIT_PHASE: 'BB_INIT_PHASE',
        BB_AUTHENTICATE_PHASE: 'BB_AUTHENTICATE_PHASE',
        BB_CONFIRM_PHASE: 'BB_CONFIRM_PHASE',
        BB_PAYED_PHASE: 'BB_PAYED_PHASE',
        BB_CANCELED_PHASE: 'BB_CANCELED_PHASE'
    };
    var bbAuthenticationComplete = 'BB_AUTHENTICATION_COMPLETE';
    var bbAuthenticationClose = 'BB_AUTHENTICATION_CLOSED';
    var isIframe = false;
    var fromRedirect = false;
    var bbScope = '';
    var bbEvoUrlLib = 'https://evopaymentsmexico.gateway.mastercard.com/form/version/62/merchant/{{merchant}}/session.js';
    var bbDefaultFields = { number: "#card-number", securityCode: "#security-code", expiryMonth: "#expiry-month", expiryYear: "#expiry-year", nameOnCard: "#cardholder-name" };
    var bbRequiredFields = ['card-number', 'security-code', 'expiry-month', 'expiry-year', 'cardholder-name'];
    var bbEvoPaymentConfigurations = {
        session: '',
        fields: {
            card: {}
        },
        //SPECIFY YOUR MITIGATION OPTION HERE
        frameEmbeddingMitigation: ["x-frame-options", "csp"],
        callbacks: {
            initialized: (response) => {
                afterInitialized(response);
            },
            formSessionUpdate: (response) => {
                if (response.status) {
                    if ("ok" == response.status) {

                        var bbResultErrorField = {
                            isValid: true,
                            hasError: false,
                            errorReason: '',
                            isIncomplete: false,
                            isEmpty: false
                        };

                        var securityCodeResult = JSON.parse(JSON.stringify(bbResultErrorField));

                        if (response.sourceOfFunds.provided.card.securityCode) {
                            formSessionUpdated = formSessionUpdated && true;
                        } else {
                            formSessionUpdated = false;
                            sucurityCodeValid = false;
                            sucurityCodeEmpty = true;
                            securityCodeResult.hasError = true;
                            securityCodeResult.isEmpty = true;
                            securityCodeResult.isValid = false;
                            securityCodeResult.errorReason = 'EMPTY';
                        }
                        securityCodeResult['selector'] = bbDefaultFields['securityCode'];
                        bbSelectErrorValidation('securityCode', securityCodeResult);

                        //////////////////////////////////////////////


                        var yearResult = JSON.parse(JSON.stringify(bbResultErrorField));

                        if (response.sourceOfFunds.provided.card.expiry.year) {
                            formSessionUpdated = formSessionUpdated && true;
                        } else {
                            formSessionUpdated = false;
                            yearResult.hasError = true;
                            yearResult.isEmpty = true;
                            yearResult.isValid = false;
                            yearResult.errorReason = 'EMPTY';
                        }
                        yearResult['selector'] = bbDefaultFields['expiryYear'];
                        bbSelectErrorValidation('expiryYear', yearResult);

                        /////////////////////////////////////////////


                        var monthResult = JSON.parse(JSON.stringify(bbResultErrorField));

                        if (response.sourceOfFunds.provided.card.expiry.month) {
                            formSessionUpdated = formSessionUpdated && true;
                        } else {
                            formSessionUpdated = false;
                            monthResult.hasError = true;
                            monthResult.isEmpty = true;
                            monthResult.isValid = false;
                            monthResult.errorReason = 'EMPTY';
                        }
                        monthResult['selector'] = bbDefaultFields['expiryMonth'];
                        bbSelectErrorValidation('expiryMonth', monthResult);

                        ////////////////////////////////////////////


                        var numberResult = JSON.parse(JSON.stringify(bbResultErrorField));

                        if (response.sourceOfFunds.provided.card.number) {
                            formSessionUpdated = formSessionUpdated && true;
                        } else {
                            formSessionUpdated = false;
                            numberResult.hasError = true;
                            numberResult.isEmpty = true;
                            numberResult.isValid = false;
                            numberResult.errorReason = 'EMPTY';
                        }
                        numberResult['selector'] = bbDefaultFields['number'];
                        bbSelectErrorValidation('number', numberResult);

                        ////////////////////////////////////////////


                        var nameOnCardResult = JSON.parse(JSON.stringify(bbResultErrorField));

                        if (response.sourceOfFunds.provided.card.nameOnCard) {
                            formSessionUpdated = formSessionUpdated && true;
                        } else {
                            formSessionUpdated = false;
                            nameOnCardResult.hasError = true;
                            nameOnCardResult.isEmpty = true;
                            nameOnCardResult.isValid = false;
                            nameOnCardResult.errorReason = 'EMPTY';
                        }
                        nameOnCardResult['selector'] = bbDefaultFields['nameOnCard'];
                        bbSelectErrorValidation('nameOnCard', nameOnCardResult);

                        if (formSessionUpdated) {
                            formSessionUpdateCallBack();
                        } else {
                            bbEnableAllBtns();
                        }
                    } else if ("fields_in_error" == response.status) {

                        console.log("Session update failed with field errors.");
                        if (response.errors.cardNumber) {
                            console.log("Card number invalid or missing.");
                            bbRequestError({ response: response.errors });
                        }
                        if (response.errors.expiryYear) {
                            console.log("Expiry year invalid or missing.");
                            bbRequestError({ response: response.errors });
                        }
                        if (response.errors.expiryMonth) {
                            bbConsoleLog("Expiry month invalid or missing.");
                            bbRequestError({ response: response.errors });
                        }
                        if (response.errors.securityCode) {
                            console.log("Security code invalid.");
                            bbRequestError({ response: response.errors });
                        }
                    } else if ("request_timeout" == response.status) {
                        console.log("Session update failed with request timeout: " + response.errors.message);
                    } else if ("system_error" == response.status) {
                        console.log("formSessionUpdate system_error", response);
                        if (response.message) {
                            if (response.message.includes('Form Session')) {
                                bbRequestError({ response: JSON.stringify({ message: response.message }) });
                            }
                        } else if (response.errors && response.errors.message) {
                            if (response.errors.message.includes('Form Session')) {
                                bbRequestError({ response: JSON.stringify({ message: response.errors.message }) });
                            }
                        }
                    }
                } else {
                    console.log("Session update failed: " + response);
                }
            }
        },
        interaction: {
            displayControl: {
                formatCard: "EMBOSSED",
                invalidFieldCharacters: "ALLOW"
            }
        },
        order: {}
    }

    var bbHtmlComponentsNoModal = '<div class="bb-nomodal bb-fade" id="bb-payment-modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"><div class="bb-container bb-nomodal-dialog lightbox" id="bb-payment-modal-dialog">{{html-general}}</div></div>';

    var bbHtmlComponentsModal = '<div class="bb-modal bb-fade" id="bb-payment-modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"><div class="bb-container bb-modal-dialog lightbox" id="bb-payment-modal-dialog">{{html-general}}</div></div>';

    var htmlComponentGeneral = '<div class="bb-modal-content"><div class="bb-modal-header"><h5 class="bb-modal-title" id="campusModalLabel"></h5></div><div id="bb-card-preload" class="bb-modal-body bb-card-preload"><div class="bb-row"><div class="bb-col-12"><div class="bb-row examples"><div class="snippet" data-title=".dot-pulse"><div class="stage"><div class="dot-pulse"></div></div></div></div><div class="bb-row"><div class="bb-col-6 bb-offset-3"><div class="bb-text-center"><strong class="bb-loading-content-text">Iniciando motor de pagos</strong></div></div></div></div></div></div><div id="bb-card-content" class="bb-modal-body bb-card-content bb-hide"><div id="divParent"><div id="bbPayment" class="bbPayment bb-container-fluid"><div class="bb-row"><div class="bb-col-12"><div class="bb-row"><div class="bb-col-12 bb-mb-3"><div class="bb-row bb-mb-2"><div class="bb-col-10"><label class="bb-small-label" for="card-number"><b>N&uacute;mero de tarjeta</b></label><input type="text" id="card-number" class="bb-form-control" title="Número de tarjeta" aria-label="Número de tarjeta" value="" tabindex="1" readonly required /><label class="bb-x-small-label bb-danger bb-bold bb-label-block" for="card-number" id="error-card-number"></label></div></div><div class="bb-row"><div class="col-12 bb-ml-1"><span class="bb-amexCardLogo bb-hppPaymentTypeSupported"></span><span class="bb-visaCardLogo bb-hppPaymentTypeSupported"></span><span class="bb-mastercardCardLogo bb-hppPaymentTypeSupported"></span><span class="bb-carnetCardLogo bb-hppPaymentTypeSupported"></span></div></div></div><div class="bb-col-12 bb-mb-3"><div class="bb-row"><div class="bb-col-6"><div class="bb-row"><div class="bb-col-12"><label class="bb-small-label" for="expiry-month"><b>Mes de vencimiento</b></label></div></div><div class="bb-row"><div class="bb-col-6"><select id="expiry-month" class="bb-form-control" tabindex="2" readonly required><option value="">MM</option><option value="01">01</option><option value="02">02</option><option value="03">03</option><option value="04">04</option><option value="05">05</option><option value="06">06</option><option value="07">07</option><option value="08">08</option><option value="09">09</option><option value="10">10</option><option value="11">11</option><option value="12">12</option></select></div></div><div class="bb-row"><div class="bb-col-12"><label class="bb-x-small-label bb-danger bb-bold bb-label-block" for="expiry-month" id="error-expiry-month"></label></div></div></div><div class="bb-col-6"><div class="bb-row"><div class="bb-col-12"><label class="bb-small-label" for="expiry-year"><b>A&ntilde;o de vencimiento</b></label></div></div><div class="bb-row"><div class="bb-col-6"><select id="expiry-year" class="bb-form-control" tabindex="3" readonly required><option value="">AA</option><option>21</option><option>22</option><option>23</option><option>24</option><option>25</option><option>26</option><option>27</option><option>28</option><option>29</option><option>30</option><option>31</option><option>32</option><option>33</option><option>34</option><option>35</option><option>36</option><option>37</option><option>38</option><option>39</option><option>40</option><option>41</option><option>42</option></select></div></div><div class="bb-row"><div class="bb-col-12"><label class="bb-x-small-label bb-danger bb-bold bb-label-block" for="expiry-year" id="error-expiry-year"></label></div></div></div></div></div><div class="bb-col-10 bb-mb-3"><label class="bb-small-label" for="cardholder-name"><b>Nombre del titular de la tarjeta* </b></label><input type="text" id="cardholder-name" class="bb-form-control" title="cardholder name" aria-label="enter name on card" value="" tabindex="4" readonly required /><label class="bb-x-small-label bb-danger bb-bold bb-label-block" for="cardholder-name" id="error-cardholder-name"></label></div><div class="bb-col-12 bb-mb-3"><div class="bb-row"><div class="bb-col-12"><label class="bb-small-label" for="security-code"><b>C&oacute;digo de seguridad *</b></label></div></div><div class="bb-row"><div class="bb-col-4"><input type="text" id="security-code" class="bb-form-control" title="Código de seguridad" aria-label="Código de seguridad" value="" tabindex="5" readonly required /></div><div class="bb-col-1"></div><div class="bb-col-1"><span class="bb-cscOtherLogo bb-hppPaymentTypeSupported"></span></div><div class="bb-col-6"><span class="bb-x-small"><b>3 d&iacute;gitos</b> en el reverso de la tarjeta</span></div></div><div class="bb-row"><div class="bb-col-12"><label class="bb-x-small-label bb-danger bb-bold bb-label-block" for="security-code" id="error-security-code"></label></div></div></div><div class="bb-col-12 bb-text-justify bb-mb-3"><span class="bb-x-small"><b>La siguiente pantalla que aparece puede ser la verificaci&oacute;n de tarjetas de pago con el emisor de su tarjeta.</b></span></div></div></div></div></div></div></div><div id="bb-loading-content" class="bb-modal-body bb-loading-content bb-hide"><div class="bb-row"><div class="bb-col-12"><div class="bb-row examples"><div class="snippet" data-title=".dot-pulse"><div class="stage"><div class="dot-pulse"></div></div></div></div><div class="bb-row"><div class="bb-col-6 bb-offset-3"><div class="bb-text-center"><strong class="bb-loading-content-text">Aplicando pago...</strong></div></div></div></div></div></div><div id="bb-payment-plans-content" class="bb-modal-body bb-payment-plans-content bb-hide"><div class="bb-row"><div class="bb-col-12"><div class="bb-row"><div class="bb-col-12"><h6>Opciones de plan de pago</h6></div></div><div class="bb-row bb-payment-plans"><div class="bb-col-12 bb-payment-plans-tables"></div></div></div></div></div><div id="bb-error-content" class="bb-modal-body bb-error-content bb-hide"><div class="bb-row"><div class="bb-col-12"><div class="bb-row"><div class="bb-col-12"><div class="bb-text-center"><strong>La transacción no puede ser completada:</strong></div></div></div><div class="bb-row bb-mt-4 bb-error-content-important-container"><div class="bb-col-12"><div class="bb-text-center"><span class="bb-error-content-important-text"></span></div></div></div><div class="bb-row bb-mt-4"><div class="bb-col-12"><div class="bb-text-center"><span class="bb-check-info-message">Revisa que tus datos sean correctos e inténtalo de nuevo.</span></div></div></div><div class="bb-row bb-additional-info-content"><div class="bb-col-12"><div class="bb-row"><div class="bb-col-12 bb-mb-1"><h6>Para mayor información puedes solicitar apoyo proporcionando estos datos</h6></div></div><div class="bb-row"><div class="bb-col-4"><span class="bb-additional-info-label">RequestId:</span></div><div class="bb-col-8"><span class="bb-additional-info-text" id="text-request-id">{{text-request-id}}</span></div></div><div class="bb-row"><div class="bb-col-4"><span class="bb-additional-info-label">SessionId:</span></div><div class="bb-col-8"><span class="bb-additional-info-text" id="text-session-id">{{text-session-id}}</span></div></div><div class="bb-row"><div class="bb-col-4"><span class="bb-additional-info-label"> MerchanId:</span></div><div class="bb-col-8"><span class="bb-additional-info-text" id="text-merchan-id">{{text-merchan-id}}</span></div></div></div><div class="bb-col-12"><div class="bb-text-justify"><span class="bb-error-content-text"></span></div></div></div></div></div></div><div class="bb-modal-footer"><button type="button" class="bb-btn bb-btn-danger btn-close bb-hide" onclick="BankBridge.close()">Cerrar</button><button type="button" class="bb-btn bb-btn-light btn-previous-plans bb-hide" onclick="BankBridge.previous(\'payment-plans\')" disabled><span class="btn-pay-value">Anterior</span></button><button type="button" class="bb-btn bb-btn-danger btn-cancel" onclick="BankBridge.cancel()" disabled>Cancelar</button><button type="button" class="bb-btn bb-btn-success btn-next-plans bb-hide" onclick="BankBridge.next(\'payment-plans\')" disabled><span class="btn-pay-value">Siguiente</span></button><button type="button" class="bb-btn bb-btn-success btn-pay" onclick="BankBridge.pay()" disabled><span class="btn-pay-value">Pagar ahora</span></button></div><div class="bb-modal-footer"><span class="bb-supportedby"></span></div></div>';

    var bbPaymentResultsCallback = () => {},
        bbValidationCallback = () => {},
        bbPaymentPlansCallback = () => {},
        formSessionUpdateCallBack = () => {};

    var bbFieldsErrors = {
        hasError: false,
        errors: {
            number: {
                error: '',
                hasError: false
            },
            securityCode: {
                error: '',
                hasError: false
            },
            expiryMonth: {
                error: '',
                hasError: false
            },
            expiryYear: {
                error: '',
                hasError: false
            },
            nameOnCard: {
                error: '',
                hasError: false
            }
        }
    }
    var formSessionUpdated = false,
        sucurityCodeEmpty = null,
        sucurityCodeValid = null;

    var bbPayAttemps = 0;
    var bbErrorResolver, bbErrorReject, bbCompleteResolver, bbCompleteReject;

    var bbPaymentPlansData,
        bbPaymentPlans = [],
        bbPlanSelected = {
            PlanId: '',
            NumberOfPayments: null,
            NumberOfDeferrals: null
        }

    var windowObjectReference = null;
    var windowAuthenticated = false;
    var windowCloseCheckedCounter = 0;

    var configureEvoPaymentTimer;

    var numberSelector, monthSelector, yearSelector, nameSelector, ccvSelector;
    var amexCardSelector, visaCardSelector, mastercardCardSelector, carnetCardSelector;
    var btnPaySelector, btnCancelSelector, btnNextSelector, btnPrevSelector, btnPaySpinnerSelector;
    var bbLoadingContentSelector, bbCardContentSelector, bbErrorContentSelector, bbPaymentPlanContentSelector, bbErrorContentTextSelector, bbLoadingContentTextSelector, bbPreloadContentSelector, bbErrorImportantContentTextSelector, bbErrorImportantContentContainerSelector, bbCheckInfoMessageSelector;
    var numberInputSelector, securityCodeInputSelector, expiryMonthInputSelector, expiryYearInputSelector, nameOnCardInputSelector;
    var errornumberInputSelector, errorsecurityCodeInputSelector, errorexpiryMonthInputSelector, errorexpiryYearInputSelector, errornameOnCardInputSelector;

    var radioControls, selectControls;
    var bbEvoLibLoaded = false;

    Object.defineProperty(this, 'bbEvoLibLoaded', {
        get: () => bbEvoLibLoaded,
        set: (value) => bbEvoLibLoaded = value
    });
    Object.defineProperty(this, 'bbConfig', {
        get: () => bbConfig,
        set: (value) => bbConfig = value
    });
    Object.defineProperty(this, 'bbUrlBase', {
        get: () => bbUrlBase,
        set: (value) => bbUrlBase = value
    });
    Object.defineProperty(this, 'bbToken', {
        get: () => bbToken,
        set: (value) => bbToken = value
    });
    Object.defineProperty(this, 'bbCardFields', {
        get: () => bbCardFields,
        set: (value) => bbCardFields = value
    });
    Object.defineProperty(this, 'bbScope', {
        get: () => bbScope,
        set: (value) => bbScope = value
    });
    Object.defineProperty(this, 'bbEvoUrlLib', {
        get: () => bbEvoUrlLib,
        set: (value) => bbEvoUrlLib = value
    });

    Object.defineProperty(this, 'bbDefaultFields', {
        get: () => bbDefaultFields,
        set: (value) => bbDefaultFields = value
    });
    Object.defineProperty(this, 'bbRequiredFields', {
        get: () => bbRequiredFields,
        set: (value) => bbRequiredFields = value
    });
    Object.defineProperty(this, 'bbEvoPaymentConfigurations', {
        get: () => bbEvoPaymentConfigurations,
        set: (value) => bbEvoPaymentConfigurations = value
    });

    Object.defineProperty(this, 'bbHtmlComponentsNoModal', {
        get: () => bbHtmlComponentsNoModal,
        set: (value) => bbHtmlComponentsNoModal = value
    });
    Object.defineProperty(this, 'bbHtmlComponentsModal', {
        get: () => bbHtmlComponentsModal,
        set: (value) => bbHtmlComponentsModal = value
    });
    Object.defineProperty(this, 'htmlComponentGeneral', {
        get: () => htmlComponentGeneral,
        set: (value) => htmlComponentGeneral = value
    });

    Object.defineProperty(this, 'bbPaymentResultsCallback', {
        get: () => bbPaymentResultsCallback,
        set: (value) => bbPaymentResultsCallback = value
    });
    Object.defineProperty(this, 'bbValidationCallback', {
        get: () => bbValidationCallback,
        set: (value) => bbValidationCallback = value
    });
    Object.defineProperty(this, 'bbPaymentPlansCallback', {
        get: () => bbPaymentPlansCallback,
        set: (value) => bbPaymentPlansCallback = value
    });
    Object.defineProperty(this, 'formSessionUpdateCallBack', {
        get: () => formSessionUpdateCallBack,
        set: (value) => formSessionUpdateCallBack = value
    });

    Object.defineProperty(this, 'bbFieldsErrors', {
        get: () => bbFieldsErrors,
        set: (value) => bbFieldsErrors = value
    });

    Object.defineProperty(this, 'formSessionUpdated', {
        get: () => formSessionUpdated,
        set: (value) => formSessionUpdated = value
    });
    Object.defineProperty(this, 'sucurityCodeEmpty', {
        get: () => sucurityCodeEmpty,
        set: (value) => sucurityCodeEmpty = value
    });
    Object.defineProperty(this, 'sucurityCodeValid', {
        get: () => sucurityCodeValid,
        set: (value) => sucurityCodeValid = value
    });
    Object.defineProperty(this, 'bbPayAttemps', {
        get: () => bbPayAttemps,
        set: (value) => bbPayAttemps = value
    });

    Object.defineProperty(this, 'bbErrorResolver', {
        get: () => bbErrorResolver,
        set: (value) => bbErrorResolver = value
    });
    Object.defineProperty(this, 'bbErrorReject', {
        get: () => bbErrorReject,
        set: (value) => bbErrorReject = value
    });
    Object.defineProperty(this, 'bbCompleteResolver', {
        get: () => bbCompleteResolver,
        set: (value) => bbCompleteResolver = value
    });
    Object.defineProperty(this, 'bbCompleteReject', {
        get: () => bbCompleteReject,
        set: (value) => bbCompleteReject = value
    });

    Object.defineProperty(this, 'bbPaymentPlansData', {
        get: () => bbPaymentPlansData,
        set: (value) => bbPaymentPlansData = value
    });
    Object.defineProperty(this, 'bbPaymentPlans', {
        get: () => bbPaymentPlans,
        set: (value) => bbPaymentPlans = value
    });
    Object.defineProperty(this, 'bbPlanSelected', {
        get: () => bbPlanSelected,
        set: (value) => bbPlanSelected = value
    });

    Object.defineProperty(this, 'windowObjectReference', {
        get: () => windowObjectReference,
        set: (value) => windowObjectReference = value
    });
    Object.defineProperty(this, 'windowAuthenticated', {
        get: () => windowAuthenticated,
        set: (value) => windowAuthenticated = value
    });
    Object.defineProperty(this, 'windowCloseCheckedCounter', {
        get: () => windowCloseCheckedCounter,
        set: (value) => windowCloseCheckedCounter = value
    });
    Object.defineProperty(this, 'configureEvoPaymentTimer', {
        get: () => configureEvoPaymentTimer,
        set: (value) => configureEvoPaymentTimer = value
    });
    Object.defineProperty(this, 'bbCurrentPhase', {
        get: () => bbCurrentPhase,
        set: (value) => bbCurrentPhase = value
    });
    Object.defineProperty(this, 'bbPhases', {
        get: () => bbPhases,
        set: (value) => bbPhases = value
    });

    Object.defineProperty(this, 'numberSelector', {
        get: () => numberSelector,
        set: (value) => numberSelector = value
    });
    Object.defineProperty(this, 'monthSelector', {
        get: () => monthSelector,
        set: (value) => monthSelector = value
    });
    Object.defineProperty(this, 'yearSelector', {
        get: () => yearSelector,
        set: (value) => yearSelector = value
    });
    Object.defineProperty(this, 'nameSelector', {
        get: () => nameSelector,
        set: (value) => nameSelector = value
    });
    Object.defineProperty(this, 'ccvSelector', {
        get: () => ccvSelector,
        set: (value) => ccvSelector = value
    });
    Object.defineProperty(this, 'amexCardSelector', {
        get: () => amexCardSelector,
        set: (value) => amexCardSelector = value
    });
    Object.defineProperty(this, 'visaCardSelector', {
        get: () => visaCardSelector,
        set: (value) => visaCardSelector = value
    });
    Object.defineProperty(this, 'mastercardCardSelector', {
        get: () => mastercardCardSelector,
        set: (value) => mastercardCardSelector = value
    });
    Object.defineProperty(this, 'carnetCardSelector', {
        get: () => carnetCardSelector,
        set: (value) => carnetCardSelector = value
    });
    Object.defineProperty(this, 'btnPaySelector', {
        get: () => btnPaySelector,
        set: (value) => btnPaySelector = value
    });
    Object.defineProperty(this, 'btnCancelSelector', {
        get: () => btnCancelSelector,
        set: (value) => btnCancelSelector = value
    });
    Object.defineProperty(this, 'btnNextSelector', {
        get: () => btnNextSelector,
        set: (value) => btnNextSelector = value
    });
    Object.defineProperty(this, 'btnPrevSelector', {
        get: () => btnPrevSelector,
        set: (value) => btnPrevSelector = value
    });
    Object.defineProperty(this, 'btnPaySpinnerSelector', {
        get: () => btnPaySpinnerSelector,
        set: (value) => btnPaySpinnerSelector = value
    });
    Object.defineProperty(this, 'bbLoadingContentSelector', {
        get: () => bbLoadingContentSelector,
        set: (value) => bbLoadingContentSelector = value
    });
    Object.defineProperty(this, 'bbCardContentSelector', {
        get: () => bbCardContentSelector,
        set: (value) => bbCardContentSelector = value
    });
    Object.defineProperty(this, 'bbCheckInfoMessageSelector', {
        get: () => bbCheckInfoMessageSelector,
        set: (value) => bbCheckInfoMessageSelector = value
    });
    Object.defineProperty(this, 'bbErrorImportantContentContainerSelector', {
        get: () => bbErrorImportantContentContainerSelector,
        set: (value) => bbErrorImportantContentContainerSelector = value
    });
    Object.defineProperty(this, 'bbErrorImportantContentTextSelector', {
        get: () => bbErrorImportantContentTextSelector,
        set: (value) => bbErrorImportantContentTextSelector = value
    });
    Object.defineProperty(this, 'bbPreloadContentSelector', {
        get: () => bbPreloadContentSelector,
        set: (value) => bbPreloadContentSelector = value
    });
    Object.defineProperty(this, 'bbErrorContentSelector', {
        get: () => bbErrorContentSelector,
        set: (value) => bbErrorContentSelector = value
    });
    Object.defineProperty(this, 'bbPaymentPlanContentSelector', {
        get: () => bbPaymentPlanContentSelector,
        set: (value) => bbPaymentPlanContentSelector = value
    });
    Object.defineProperty(this, 'bbErrorContentTextSelector', {
        get: () => bbErrorContentTextSelector,
        set: (value) => bbErrorContentTextSelector = value
    });
    Object.defineProperty(this, 'bbLoadingContentTextSelector', {
        get: () => bbLoadingContentTextSelector,
        set: (value) => bbLoadingContentTextSelector = value
    });
    Object.defineProperty(this, 'numberInputSelector', {
        get: () => numberInputSelector,
        set: (value) => numberInputSelector = value
    });
    Object.defineProperty(this, 'securityCodeInputSelector', {
        get: () => securityCodeInputSelector,
        set: (value) => securityCodeInputSelector = value
    });
    Object.defineProperty(this, 'expiryMonthInputSelector', {
        get: () => expiryMonthInputSelector,
        set: (value) => expiryMonthInputSelector = value
    });
    Object.defineProperty(this, 'expiryYearInputSelector', {
        get: () => expiryYearInputSelector,
        set: (value) => expiryYearInputSelector = value
    });
    Object.defineProperty(this, 'nameOnCardInputSelector', {
        get: () => nameOnCardInputSelector,
        set: (value) => nameOnCardInputSelector = value
    });


    Object.defineProperty(this, 'errornumberInputSelector', {
        get: () => errornumberInputSelector,
        set: (value) => errornumberInputSelector = value
    });
    Object.defineProperty(this, 'errorsecurityCodeInputSelector', {
        get: () => errorsecurityCodeInputSelector,
        set: (value) => errorsecurityCodeInputSelector = value
    });
    Object.defineProperty(this, 'errorexpiryMonthInputSelector', {
        get: () => errorexpiryMonthInputSelector,
        set: (value) => errorexpiryMonthInputSelector = value
    });
    Object.defineProperty(this, 'errorexpiryYearInputSelector', {
        get: () => errorexpiryYearInputSelector,
        set: (value) => errorexpiryYearInputSelector = value
    });
    Object.defineProperty(this, 'errornameOnCardInputSelector', {
        get: () => errornameOnCardInputSelector,
        set: (value) => errornameOnCardInputSelector = value
    });

    Object.defineProperty(this, 'radioControls', {
        get: () => radioControls,
        set: (value) => radioControls = value
    });
    Object.defineProperty(this, 'selectControls', {
        get: () => selectControls,
        set: (value) => selectControls = value
    });

    Object.defineProperty(this, 'isIframe', {
        get: () => isIframe,
        set: (value) => isIframe = value
    });
    Object.defineProperty(this, 'fromRedirect', {
        get: () => fromRedirect,
        set: (value) => fromRedirect = value
    });
    Object.defineProperty(this, 'bbAuthenticationComplete', {
        get: () => bbAuthenticationComplete,
        set: (value) => bbAuthenticationComplete = value
    });
    Object.defineProperty(this, 'bbAuthenticationClose', {
        get: () => bbAuthenticationClose,
        set: (value) => bbAuthenticationClose = value
    });
}

export default variables;